import styles from "./ProductTableActions.module.scss";
import Icon from "../../../../../assets/icons";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";
import secondaryComponents from "../../..";

const ProductTableActions = ({ product, setViews }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef();
  const [search] = useSearchParams();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <span className={`${styles.productTableOption}`} ref={menuRef}>
      <span
        style={{ cursor: "pointer", padding: 4 }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={Icon.option_alt} alt="" />
      </span>

      {isOpen ? (
        <span className={styles.dropdrown}>
          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_delete_products"
          >
            <p
              onClick={() => {
                setViews((prev) => ({ ...prev, isDelete: product }));
                setIsOpen(false);
              }}
              className="error--text"
            >
              Delete
            </p>
          </secondaryComponents.NavigateWithPermission>
          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_view_stock_history"
          >
            <p
              onClick={() => {
                setIsOpen(false);
                navigate(
                  pathConstants.INVENTORY_PRODUCT_STOCKHISTORY({
                    id: product?.id,
                  }) + `?product_id=${product?.id}`,
                );
              }}
            >
              Stock History
            </p>
          </secondaryComponents.NavigateWithPermission>
          <p
            onClick={() => {
              setIsOpen(false);
              navigate(
                pathConstants.INVENTORY_PRODUCT_ITEM_TRACKING +
                  `?store_id=${search.get("store_id")}&product_id=${product?.id}&is_sold=false`,
              );
            }}
          >
            Track Items
          </p>
        </span>
      ) : null}
    </span>
  );
};

export default ProductTableActions;
